import type { SelectFieldOption } from '../SingleSelectField/types';
import { getDependenciesValues } from '../../../context/utils/getDependencyValues';
import type { FormattedErrors } from '../../../context/utils/formatZodErrors';
import type { FormValues } from '../../../types/FormValues';
import { getIsDependenciesSatisfied } from '../../../context/utils/getIsDependenciesSatisfied';

export const getFilteredSelectOptions = <O extends SelectFieldOption>({
  options,
  allValues,
  allErrors,
  sectionKey,
}: {
  options: O[];
  allValues: FormValues;
  allErrors: FormattedErrors | null;
  sectionKey: string;
}): O[] => {
  const filteredOptions = options.filter((option) => {
    if (!option.dependsOn) {
      return true;
    }

    const dependencyValues = getDependenciesValues(allValues, sectionKey, option.dependsOn);
    const isDependencySatisfied = getIsDependenciesSatisfied(
      sectionKey,
      option.dependsOn,
      allErrors,
      dependencyValues
    );
    return isDependencySatisfied;
  });
  const includesSelectAll = filteredOptions.some((option) => 'selectAll' in option);

  if (includesSelectAll && filteredOptions.length <= 2) {
    return filteredOptions.filter((o) => !('selectAll' in o));
  }

  return filteredOptions;
};
